import { FC, useEffect, useMemo, useState } from 'react'

import { CommonProductComponent } from '../ComonProduct'
import { FixedTemplateItems } from '../ComonProduct/FixedTemplateItems'
import { AddCommonProductFooter } from '../footers/AddCommonProductFooter'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { buildFixedBucketItems } from 'featureSliced/shared/utils/menuStepChoices'

import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { ProductTemplateIdType } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'
import { KitchenInfoItemType } from '../types'

type AddFixedTemplateProductProps = {
  product: IProduct
  productTemplateId: ProductTemplateIdType
  closeProduct: () => void
}

/**
 * A template with nothing for the guest to decide: its fixed components are named
 * in the card and go into the basket with the article itself, so there is no
 * configuration step and the ordinary add button applies (QRM-665).
 */
export const AddFixedTemplateProduct: FC<AddFixedTemplateProductProps> = ({
  product,
  productTemplateId,
  closeProduct,
}) => {
  // Store
  const bucketProducts = useMySelector((state) => state.bucket.products)
  const Currency = useMySelector((state) => state.app.companyData.Currency)
  const discounts = useMySelector((state) => state.specials?.discounts)

  // State
  const [currentAmount, setCurrentAmount] = useState<number>(1)
  const kitchenInfoState = useState<KitchenInfoItemType>({})

  const menuItems = useMemo(
    () => buildFixedBucketItems(product?.menus, discounts, Currency),
    [product, discounts, Currency]
  )

  // useEffect
  useEffect(() => {
    if (bucketProducts?.length) {
      const addedProduct = bucketProducts?.find((bProduct) => {
        return (
          bProduct?.productId === product.id &&
          bProduct.productTemplateId === productTemplateId
        )
      })
      if (addedProduct) {
        kitchenInfoState[1](JSON.parse(addedProduct?.kitchenInfo))
        setCurrentAmount(addedProduct?.count)
      }
    }
  }, [bucketProducts, product])

  return (
    <>
      <CommonProductComponent
        product={product}
        productTemplateId={productTemplateId}
        kitchenInfoState={kitchenInfoState}
        currentAmount={currentAmount}
        includedSlot={<FixedTemplateItems product={product} />}
      />
      <AddCommonProductFooter
        product={product}
        productTemplateId={productTemplateId}
        selectedKitchenInfo={kitchenInfoState[0]}
        amountState={[currentAmount, setCurrentAmount]}
        closeProduct={closeProduct}
        initAmount={currentAmount}
        menuItems={menuItems}
      />
    </>
  )
}
